import React from 'react'
import Card from "@material-ui/core/Card";

export const UserStatsElement = ({user, stats}) => (
    <Card className="user-stats-card">
        <div className="avatar-block">
            <img className="user-avatar"
                 src={user.avatar ? ((process.env.NODE_ENV === 'development' ? 'http://tonesky.darlane' : '') + user.avatar) : 'https://tonesky.ru/images/no_avatar.png'}
                 alt="User avatar"/>
        </div>
        <div className="user-name">
            <span>{user.name}</span>
        </div>
        <div className="stats">
            <div className="stats-block">
                <div className="orders-counter">{stats.total_count}</div>
                <div className="orders-counter-legend">Всего заказов</div>
            </div>
            <div className="stats-block">
                <div className="orders-counter">{stats.count_cur_month}</div>
                <div className="orders-counter-legend">Заказов в этом месяце</div>
            </div>
            {/*<div className="stats-block tonesky-font-color">*/}
            {/*    <div className="orders-counter">{stats.bonuses}</div>*/}
            {/*    <div className="orders-counter-legend">У вас<br/>баллов</div>*/}
            {/*</div>*/}
        </div>
    </Card>
);



